export default __webpack_public_path__ + "static/media/travel-itinerary.2f1f3a1a.svg";